import { React, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { useLanguage } from '../../../Context/LanguageContext';

import LockerAddModal from './LockerAddModal';
import LockerInfo from '../../../Component/LockerComponent/LockerInfo';

import FetchModule from '../../Share/Network/FetchModule';
import LockerChangeNameModal from './LockerChangeNameModal';
import LockerUsingStopModal from './LockerUsingStopModal';
import LockerStartModal from './LockerStartModal';
import LockerHistoryModal from './LockerHistoryModal';
import CustomAlert from '../../Share/Normal/CustomAlert';
import LockerExtendsModal from './LockerExtendsModal';
import LockerDivisionInput from '../../../Component/LockerComponent/LockerDivisionInput';
import { ReactComponent as EmptySignSvg } from '../../../image/EmptySign.svg';

import WhiteTrashIcon from '../../../image/WhiteTrashIcon.png';

function LockerView() {
  const history = useHistory();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [isClickedAdd, setIsClickedAdd] = useState(false);
  const [isClickedChangeName, setIsClickedChangeName] = useState(false);
  const [isClickedStart, setIsClickedStart] = useState(false);
  const [isClickedStop, setIsClickedStop] = useState(false);
  const [isClickedHistory, setIsClickedHistory] = useState(false);
  const [isClickedExtend, setIsClickedExtend] = useState(false);
  const [isViewCustomAlert, setIsViewCustomAlert] = useState(false);

  const [lockerDivisions, setLockerDivisions] = useState([]);
  const [lockerInfo, setLockerInfo] = useState(undefined);
  const [isClickedAddLockerDivision, setIsClickedAddLockerDivision] = useState(false);

  const [newLockerName, setNewLockerName] = useState('');
  const [isInProgressAddLocker, setIsInProgressAddLocker] = useState(false);
  const [isInProgressDeleteLocker, setIsInProgressDeleteLocker] = useState(false);
  const [isInProgressLockerDivision, setIsInProgressLockerDivision] = useState(false);
  const [isClickedLockerDivisionId, setIsClickedLockerDivisionId] = useState(0);
  const [totalLockers, setTotalLockers] = useState([]);
  const [selectedAddLockerDivision, setSelectedAddLockerDivision] = useState({ id: 0, name: t('main.locker.all') });

  const [text, setText] = useState('');
  const [lockerData, setLockerData] = useState([]);
  const [index, setIndex] = useState(-1);
  const [lockerIndex, setLockerIndex] = useState(-1);
  const [rendering, setRendering] = useState(false);

  const AddModalRef = useRef();
  const NameModalRef = useRef();
  const StartModalRef = useRef();
  const LockerRef = useRef([]);

  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('locker/', 'GET');

        if (responseData.status === 200) {
          let divisions = responseData.data.lockerDivisions.slice();
          let lockers = responseData.data.lockers.slice();
          let newTotalLockers = [];

          divisions.unshift({ id: 0, name: t('main.locker.all') });

          for (let i = 0; i < divisions.length; i++) {
            let newDivision = {
              id: divisions[i].id,
              name: divisions[i].name,
              lockers: []
            }

            newTotalLockers.push(newDivision);
          }
          
          for (let i = 0; i < lockers.length; i++) {
            if (lockers[i].lockerDivisionId === undefined || lockers[i].lockerDivisionId === 0) newTotalLockers[0].lockers.push(lockers[i]);
            else {
              for (let j = 0; j < newTotalLockers.length; j++) {
                if (lockers[i].lockerDivisionId === newTotalLockers[j].id) {
                  newTotalLockers[j].lockers.push(lockers[i]);
                  break;
                }
              }
            }
          }

          setLockerDivisions(divisions);
          setTotalLockers(newTotalLockers);
        }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
        }
      }
    )();
  }, [history, rendering])

  // 락커 구분 이름 결정 //
  function decideDivisionText() {
    if (isClickedLockerDivisionId === 0) return t('main.locker.all');
    else {
      for (let i = 0; i < lockerDivisions.length; i++) {
        if (lockerDivisions[i].id === isClickedLockerDivisionId) return lockerDivisions[i].name;
      }
    }
  }

  function modalExitClick() {
    setSelectedAddLockerDivision({ id: 0, name: t('main.locker.all') });
    setIsClickedAdd(false);
  }

  function addModalSaveClick() {
    // var value = AddModalRef.current.getValue();

    // const fetchModule = new FetchModule();
    // (
    //   async () => {
    //     const responseData = await fetchModule.postData('locker/create/'
    //       // + window.sessionStorage.getItem('StoreId') 
    //       + window.sessionStorage.getItem('StoreId')
    //       + '/'
    //       + value, 'POST');

    //     if (responseData.status === 200) {
    //       setRendering(!rendering);
    //       setIsClickedAdd(false);
    //     }
    //     else if (responseData.status === 204) { }
    //     else if (responseData.status === 401) {
    //       alert("로그인 후 사용하세요");
    //       history.push('/');
    //     }
    //   }
    // )();


    let count = AddModalRef.current.getValue();

    if (count === 0) {
      alert(t('main.locker.enterLockerCount'));
      return;
    }
    else if (isInProgressAddLocker) {
      alert(t('main.locker.lockerSavingInProgress'));
      return;
    }

    setIsInProgressAddLocker(true);

    let requestData = {
      count: count,
      lockerDivisionId: selectedAddLockerDivision.id === 0 ? null : selectedAddLockerDivision.id
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('locker/save', 'POST', requestData);

        if (responseData.status === 200) {
          setRendering(!rendering);
          setIsInProgressAddLocker(false);
          setIsClickedAdd(false);
        }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
          setIsInProgressAddLocker(false);
        }
        else {
          alert(t('main.locker.addLockerFailed'));
          setIsInProgressAddLocker(false);
        }
      }
    )();
  }

  function changeModalSaveClick(name) {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.patchData('locker/modify/name/'
          + totalLockers[index].lockers[lockerIndex].id
          + '/'
          + name, 'PATCH');

        if (responseData.status === 200) {
          setRendering(!rendering);
          setIsClickedChangeName(false);
          setIndex(-1);
          clickMoreButton();
        }
        else if (responseData.status === 204) { }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
        }
      }
    )();
  }

  function clickMoreButton() {
    // for (var i = 0; i < lockerData.length; i++) {
    //   LockerRef.current[i].setClickedMore(false);
    // }

    for (let i = 0; i < totalLockers.length; i++) {
      for (let j = 0; j < totalLockers[i].lockers.length; j++) {
        LockerRef.current[i][j].setClickedMore(false);
      }
    }
  }

  function clickUsageHistory(index, lockerIndex) {
    setIndex(index);
    setLockerIndex(lockerIndex);
    setIsClickedHistory(true);
  }

  //
  function clickChangeState(index, lockerIndex) {
    if (totalLockers[index].lockers[lockerIndex].state === 'Using') {
      setText(t('main.locker.endUsageFirst'));
      setIsViewCustomAlert(true);
      return;
    }
    else if (totalLockers[index].lockers[lockerIndex].state === 'Invalid') {
      setText(t('main.locker.alreadyLocked'));
      setIsViewCustomAlert(true);
      return;
    }

    let state = '';

    if (totalLockers[index].lockers[lockerIndex].state === 'Empty') state = 'Invalid';

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.patchData('locker/modify/'
          + totalLockers[index].lockers[lockerIndex].id
          + '/'
          + state, 'PATCH');

        if (responseData.status === 200) {
          setRendering(!rendering);
          clickMoreButton();
        }
        else if (responseData.status === 204) { }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
        }
      }
    )();
  }


  function clickDeleteLocker(index, lockerIndex) {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.deleteData('locker/delete/'
          + totalLockers[index].lockers[lockerIndex].id, 'DELETE');

        if (responseData.status === 200) {
          setRendering(!rendering);
          clickMoreButton();
        }
        else if (responseData.status === 205) {
          setText(t('main.locker.lockerInUse'));
          setIsViewCustomAlert(true);
        }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
        }
      }
    )();
  }

  function clickChangeName(index, lockerIndex) {
    setIndex(index);
    setLockerIndex(lockerIndex);
    setIsClickedChangeName(true);
  }

  function clickUsingStartOrEndOrChangeValid(index, lockerIndex) {
    setIndex(index);
    setLockerIndex(lockerIndex);

    let state = '';

    if (totalLockers[index].lockers[lockerIndex].state === 'Invalid') {
      state = 'Empty';

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.patchData('locker/modify/'
            + totalLockers[index].lockers[lockerIndex].id
            + '/'
            + state, 'PATCH');

          if (responseData.status === 200) {
            setRendering(!rendering);
            clickMoreButton();
          }
          else if (responseData.status === 204) { }
          else if (responseData.status === 401) {
            alert(t('main.locker.loginRequired'));
            history.push('/');
          }
        }
      )();
      return;
    }

    if (totalLockers[index].lockers[lockerIndex].state === 'Using') setIsClickedStop(true);
    else if (totalLockers[index].lockers[lockerIndex].state === 'Empty') setIsClickedStart(true);
  }

  // function startModalSaveClick() {

  //   let storeId = parseInt(window.sessionStorage.getItem('StoreId'));
  //   let lockerId = totalLockers[index].lockers[lockerIndex].id;
  //   let memberId = StartModalRef.current.getMemberData().memberId;
  //   let card = StartModalRef.current.getCard();
  //   let cash = StartModalRef.current.getCash();
  //   let point = StartModalRef.current.getPoint();
  //   let approvalDate = moment().format('YYYY-MM-DDTHH:mm:ss');
  //   let startDate = StartModalRef.current.getStartDate() === '' ? '' : StartModalRef.current.getStartDate().format('YYYY-MM-DD') + 'T' + approvalDate.split('T')[1];
  //   let endDate = StartModalRef.current.getEndDate() === '' ? '' : StartModalRef.current.getEndDate().format('YYYY-MM-DD') + 'T23:59:59';

  //   // if (price - (cardPrice + cashPrice) < 0) {
  //   //   alert('결제금액보다 큰 금액을 입력할 수 없습니다.');
  //   //   return;
  //   // }
  //   if (startDate === '') {
  //     // alert('시작일을 선택해 주세요');
  //     setText('시작일을 선택해 주세요');
  //     setIsViewCustomAlert(true);
  //     return;
  //   }
  //   else if (endDate === '') {
  //     // alert('종료일을 선택해 주세요');
  //     setText('종료일을 선택해 주세요');
  //     setIsViewCustomAlert(true);
  //     return;
  //   }
  //   else if (memberId === 0 || memberId === undefined) {
  //     // alert('사용할 회원을 선택해주세요');
  //     setText('사용할 회원을 선택해주세요');
  //     setIsViewCustomAlert(true);
  //     return;
  //   }

  //   let data = {
  //     storeId: storeId,
  //     lockerId: lockerId,
  //     memberId: memberId,
  //     startDate: startDate,
  //     endDate: endDate,
  //     approvalDate: approvalDate,
  //     cardPrice: card === 0 ? card : card.replaceAll(',', ''),
  //     cashPrice: cash === 0 ? cash : cash.replaceAll(',', ''),
  //     point: point === 0 ? point : point.replaceAll(',', '')
  //   }

  //   const fetchModule = new FetchModule();
  //   (
  //     async () => {
  //       const responseData = await fetchModule.postDataVersion2('locker/start', 'POST', data);

  //       if (responseData.status === 200) {
  //         setRendering(!rendering);
  //         setIsClickedStart(false);
  //         setIndex(-1);
  //         clickMoreButton();
  //       }
  //       else if (responseData.status === 201) {
  //         setText(responseData.error);
  //         setIsViewCustomAlert(true);
  //       }
  //       else if (responseData.status === 204) {
  //         if (responseData.error === 'Locker Already Using') {
  //           // alert("이미 사용중인 락커입니다.");
  //           setText('이미 사용중인 락커입니다.');
  //           setIsViewCustomAlert(true);
  //         }
  //         else if (responseData.error === 'Invalid Using') {
  //           // alert("사용이 불가능한 락커입니다.");
  //           setText('사용이 불가능한 락커입니다.');
  //           setIsViewCustomAlert(true);
  //         }
  //         else if (responseData.error === 'Invalid User Data') {
  //           // alert("올바르지 않은 회원 정보입니다.");
  //           setText('올바르지 않은 회원 정보입니다.');
  //           setIsViewCustomAlert(true);
  //         }
  //       }
  //       else if (responseData.status === 401) {
  //         alert("로그인 후 사용하세요");
  //         history.push('/');
  //       }
  //     }
  //   )();
  // }

  function stopModalSaveClick() {
    let requestData = {
      usageId: totalLockers[index].lockers[lockerIndex].usageId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('locker/stop/', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('main.locker.usageEnded'));
          setRendering(!rendering);
          setIsClickedStop(false);
          setIndex(-1);
          clickMoreButton();
        }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/');
        }
        else {
          alert(t('main.locker.stopFailed'));
        }
      }
    )();
  }

  // 문자발송 버튼 클릭시
  function onClickSendMessageButton(index) {

    let text = lockerData[index].userName + '님, 지금까지 이용하셨던 락커 ' + lockerData[index].lockerName + '이(가) 만료되었어요';

    let requestData = {
      userId: lockerData[index].linkCoachId,
      data: text,
      location: 'Reservation',
      jsonData: ''
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfCoach('push_notification/send', 'POST', requestData);

        if (responseData.status === 200) {
          // alert("푸시알림을 전송하였습니다!");
          setText('푸시알림을 전송하였습니다!');
          setIsViewCustomAlert(true);
          LockerRef.current[index].setClickedMore(false);
        }
        else if (responseData.status === 204) {
          // alert("Link Coach를 탈퇴한 회원입니다!");
          setText('Link Coach에 가입되어있지 않은 회원입니다!');
          setIsViewCustomAlert(true);
          LockerRef.current[index].setClickedMore(false);
        }
      }
    )();
  }

  // 사용 연장버튼 클릭시 //
  function onClickExtendsButton(index, lockerIndex) {
    // setLockerInfo(lockerData[index]);

    setIndex(index);
    setLockerIndex(lockerIndex);
    setIsClickedExtend(true);
  }

  // 락커 추가 버튼 클릭시 //
  function onClickLockerDivisionAddButton() {
    if (isClickedAddLockerDivision) {
      if (newLockerName === '') {
        alert(t('main.locker.enterDivisionName'));
        return;
      }
      else if (isInProgressLockerDivision) {
        alert(t('main.locker.addingInProgress'));
        return;
      }

      setIsInProgressLockerDivision(true);

      let requestData = {
        name: newLockerName
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('locker/division/save', 'POST', requestData);

          if (responseData.status === 200) {
            let divisions = lockerDivisions.slice();
            divisions.push(responseData.data);
            setLockerDivisions(divisions);

            let newTotalLockers = totalLockers.slice();
            newTotalLockers.push({
              id: responseData.data.id,
              name: responseData.data.name,
              lockers: []
            });
            setTotalLockers(newTotalLockers);

            setIsInProgressLockerDivision(false);
            setIsClickedAddLockerDivision(false);
            setIsClickedLockerDivisionId(responseData.data.id);
            setNewLockerName('');
          }
          else {
            setIsInProgressLockerDivision(false);
            setNewLockerName('');
          }
        }
      )();
    }
    else setIsClickedAddLockerDivision(true);
  }

  // 락커 구분 삭제 버튼 클릭시 //
  function onClickLockerDivisionDeleteButton() {
    if (isInProgressDeleteLocker) {
      alert(t('main.locker.divisionDeleteInProgress'));
      return;
    }

    setIsClickedAddLockerDivision(false);
    setIsInProgressDeleteLocker(true);

    let requestData = {
      lockerDivisionId: isClickedLockerDivisionId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('locker/division/delete', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('main.locker.deleteComplete'));
          setRendering(!rendering);
          setIsClickedLockerDivisionId(0);
          setIsInProgressDeleteLocker(false);
        }
        else if (responseData.status === 201) {
          alert(t('main.locker.lockersExistInDivision'));
          setIsInProgressDeleteLocker(false);
        }
        else {
          alert(t('main.locker.divisionDeleteFailed'));
          setIsInProgressDeleteLocker(false);
        }
      }
    )();
  }

  function onClickExitStartLockerModal() {
    setIsClickedStart(false);
    setRendering(!rendering);
    setIndex(-1);
  }

  return (
    <TopLevelWrapper>
      {isViewCustomAlert && <CustomAlert text={text} closeFn={() => setIsViewCustomAlert(false)} />}
      {
        isClickedAdd &&
        <LockerAddModal
          ref={AddModalRef}
          lockerDivisions={lockerDivisions}
          selectedAddLockerDivision={selectedAddLockerDivision}
          setSelectedAddLockerDivision={setSelectedAddLockerDivision}
          exitClick={modalExitClick}
          saveClick={addModalSaveClick} />
      }
      {isClickedChangeName && <LockerChangeNameModal ref={NameModalRef} data={totalLockers} index={index} lockerIndex={lockerIndex} exitClick={() => setIsClickedChangeName(false)} saveClick={changeModalSaveClick} />}
      {isClickedStop && <LockerUsingStopModal data={totalLockers[index].lockers[lockerIndex]} exitClick={() => setIsClickedStop(false)} saveClick={stopModalSaveClick} />}
      {isClickedStart && <LockerStartModal ref={StartModalRef} lockerData={totalLockers[index].lockers[lockerIndex]} exitClick={onClickExitStartLockerModal}  />}
      {isClickedHistory && <LockerHistoryModal data={totalLockers[index].lockers[lockerIndex]} exitClick={() => setIsClickedHistory(false)} />}
      {isClickedExtend && <LockerExtendsModal memberData={{ name: totalLockers[index].lockers[lockerIndex].userName }} recentlyMembership={undefined} lockerData={totalLockers[index].lockers[lockerIndex]} lockerRendering={() => setRendering(!rendering)} closeFn={() => setIsClickedExtend(false)} />}
      <TopComponentWrapper>
        <TitleWrapper>
          <Title>{t('main.locker.title')}</Title>
          <Explanation>{t('main.locker.pageDesc')}</Explanation>
        </TitleWrapper>
        <AddButton onClick={() => setIsClickedAdd(true)}>{t('main.locker.addButton')}</AddButton>
      </TopComponentWrapper>
      <LockerDivisionButtonWrapper>
        <DivisionButtonsGroup>
          {
            lockerDivisions.map((data, index) => (
                <LockerDivisionButton
                  key={'LockerDivision-' + index}
                  isClicked={isClickedLockerDivisionId === data.id}
                  onClick={() => setIsClickedLockerDivisionId(data.id)}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={isClickedLockerDivisionId === data.id ? theme.background : theme.subText} hover='pointer'>{data.name}</Text>
              </LockerDivisionButton>
            ))
          }
          { isClickedAddLockerDivision && <LockerDivisionInput value={newLockerName} setValue={setNewLockerName} onCancel={() => { setIsClickedAddLockerDivision(false); setNewLockerName(''); }} /> }
        </DivisionButtonsGroup>
        <LockerAdditionButton data-locker-add-button isClicked={isClickedAddLockerDivision} onClick={onClickLockerDivisionAddButton}>
          {
            isClickedAddLockerDivision ?
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} hover='pointer'>{t('main.locker.addDivision')}</Text>
              :
              <LockerPlusWrapper>
                <Stick width={12} height={2} />
                <Stick width={2} height={12} />
              </LockerPlusWrapper>
          }
        </LockerAdditionButton>
      </LockerDivisionButtonWrapper>
      <TotalViewBoxWrapper>
        <DivisionBoxWrapper>
          {
            isClickedLockerDivisionId !== 0 &&
            <DivisionDeleteBox onClick={onClickLockerDivisionDeleteButton}>
              <DivisionDeleteIcon src={WhiteTrashIcon}/>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.white} hover='pointer'>{t('main.locker.deleteDivision')}</Text>
            </DivisionDeleteBox>
          }
        </DivisionBoxWrapper>
        <ViewBox isFirst={isClickedLockerDivisionId === 0} $isDark={isDark}>
          {/* <InfoBox>
            {
              lockerData.map((data, index) => (
                <LockerInfo
                  key={index}
                  data={data}
                  index={index}
                  ref={element => (LockerRef.current[index] = element)}
                  clickUsageHistoryFn={clickUsageHistory}
                  clickFunctionFn={clickUsingStartOrEndOrChangeValid}
                  clickChangeStateFn={clickChangeState}
                  clickDeleteLockerFn={clickDeleteLocker}
                  clickChangeNameFn={clickChangeName}
                  clickSendMessageFn={onClickSendMessageButton}
                  clickExtendFn={onClickExtendsButton}/>
              ))
            }
          </InfoBox> */}
          {
            (isClickedLockerDivisionId === 0
              ? totalLockers.reduce((sum, division) => sum + division.lockers.length, 0)
              : (totalLockers.find(division => division.id === isClickedLockerDivisionId)?.lockers.length || 0)
            ) === 0 ?
            <NoneLockerBox>
              <EmptyImage $isDark={isDark} />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{t('main.locker.noLocker')}</Text>
            </NoneLockerBox>
            :
            <DivisionInfoBox>
              {
                totalLockers.map((data, index) => (
                  (isClickedLockerDivisionId === 0 || data.id === isClickedLockerDivisionId) &&
                  <InfoBoxWrapper>
                    {
                      (isClickedLockerDivisionId === 0 && index !== 0) &&
                      <DivisionNameBoxWrapper>
                        <DivisionNameBox>
                          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.white} hover='default'>{data.name}</Text>
                        </DivisionNameBox>
                      </DivisionNameBoxWrapper>
                    }
                    <InfoBox>
                      {
                        data.lockers.map((locker, lockerIndex) => (
                          <LockerInfo
                            key={lockerIndex}
                            data={locker}
                            index={index}
                            lockerIndex={lockerIndex}
                            // ref={element => (LockerRef.current[(index) * (lockerIndex)] = element)}
                            ref={element => {
                              // 해당 row 배열이 없으면 초기화
                              if (!LockerRef.current[index]) {
                                LockerRef.current[index] = [];
                              }
                              // rowIndex, colIndex에 해당하는 위치에 element 할당
                              LockerRef.current[index][lockerIndex] = element;
                            }}
                            clickUsageHistoryFn={clickUsageHistory}
                            clickFunctionFn={clickUsingStartOrEndOrChangeValid}
                            clickChangeStateFn={clickChangeState}
                            clickDeleteLockerFn={clickDeleteLocker}
                            clickChangeNameFn={clickChangeName}
                            clickSendMessageFn={onClickSendMessageButton}
                            clickExtendFn={onClickExtendsButton} />
                        ))
                      }
                    </InfoBox>
                    {(isClickedLockerDivisionId === 0 && totalLockers.length - 1 !== index) && <DivisionLine />}
                  </InfoBoxWrapper>
                ))
              }
            </DivisionInfoBox>
          }
        </ViewBox>
      </TotalViewBoxWrapper>
    </TopLevelWrapper>
  )
}

export default LockerView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 14px;
`;

const TopComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 700px;
  margin-left: 28px
`;


const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 4px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const AddButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 38px;

  border: 1px solid ${props => props.theme.buttonStroke};
  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.subKeyHover};
  }
`;

const LockerDivisionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 24px;
  padding-left: 30px;
`;

const DivisionButtonsGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  align-items: center;

  flex: 1;
  max-width: calc(100% - 59px);

  gap: 10px;
`;

const LockerDivisionButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 5px 20px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.buttonStroke}`};
  border-radius: 11px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const LockerAdditionButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 49px;
  height: 30px;

  flex-shrink: 0;

  border: 1px solid ${props => props.theme.buttonStroke};
  border-radius: 10px;
  background-color: ${props => props.isClicked ? props.theme.subKey : props.theme.buttonFill2};

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const LockerPlusWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
`;

const Stick = styled.div`
  position: absolute;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 4px;
  background-color: ${props => props.theme.subBackground};
`;

const TotalViewBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1020px;

  margin-top: 13px;
  margin-bottom: 96px;
  margin-left: 28px;
`;

const DivisionBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  height: 25px;
`;

const DivisionBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 20px;

  height: 25px;
  
  border-radius: 5px 5px 0px 0px;
  background-color: ${props => props.theme.buttonFill2};
`;

const DivisionDeleteBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  height: 25px;
  
  gap: 10px;

  border-radius: 5px 5px 0px 0px;
  background-color: ${props => props.theme.pointRedAlpha50};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.pointRed};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const DivisionDeleteIcon = styled.img`
  width: 18px;
  height: 18px;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  // width: 1020px;

  // margin-top: 38px;
  // margin-bottom: 96px;
  // margin-left: 28px;

  padding: 28px 0px;

  width: 100%;

  border-radius: ${props => props.isFirst ? '20px 20px 20px 20px' : '20px 0px 20px 20px'};
  background-color: ${props => props.theme.subBackground};
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;

  flex-wrap: wrap;

  width: 100%;

  gap: 18px;
`;

const DivisionInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  // width: 100%;
  width: 962px;
  // width: 964px;
`;

const DivisionNameBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-bottom: 16px;

  width: 100%;
`;

const DivisionNameBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  height: 21px;

  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill2};
`;

const DivisionLine = styled.div`
  margin: 35px 0px;

  width: 100%;
  height: 1px;

  border-radius: 2px;
  background-color: ${props => props.theme.line};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;

const NoneLockerBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 10px;
  padding: 60px 0px;

  width: 100%;
`;

const EmptyImage = styled(EmptySignSvg)`
  width: 148px;
  height: 62px;

  & path:first-of-type {
    fill: ${props => props.$isDark ? props.theme.subBackground : props.theme.line};
  }

  & path:last-of-type {
    fill: ${props => props.theme.white};
  }

  & rect {
    fill: ${props => props.$isDark ? props.theme.line : props.theme.gray};
  }
`;
